import React from 'react';
import type { MarketProfileState } from '../marketProfileStore';
import { computeProgress } from '../marketProfileStore';
import MarketDataLockedState from './MarketDataLockedState';
import MarketDataOpenDashboard from './MarketDataOpenDashboard';

type Props = {
  state: MarketProfileState;
  onGoOverview: () => void;
  onOpenShare?: () => void;
  onOpenPosition?: () => void;
  onOpenGrading?: () => void;
};

export default function MarketDataTab({
  state,
  onGoOverview,
  onOpenShare,
  onOpenPosition,
  onOpenGrading,
}: Props) {
  const progress = computeProgress(state);
  const dataReady = progress.completed === 2;

  if (!dataReady) {
    return (
      <MarketDataLockedState
        state={state}
        completed={progress.completed}
        submitted={progress.submitted}
        onGoFill={onGoOverview}
        onOpenShare={onOpenShare}
        onOpenPosition={onOpenPosition}
        onOpenGrading={onOpenGrading}
      />
    );
  }

  return (
    <MarketDataOpenDashboard
      state={state}
      confirmed
    />
  );
}
